// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2UaKS","header":"PatientQuestionnaire_header__2j-mW","info":"PatientQuestionnaire_info__qQbO6"};